import { Dialog, Paper, Slide, Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import React, {
    FunctionComponent,
    useEffect,
    useLayoutEffect,
    useRef,
    useState,
} from "react";

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        height: "100%",
        "&.MuiContainer-root": {
            width: "100%",
            maxWidth: "100%",
            padding: "6px",
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            overflowY: "hidden",
        },
    },

    menuContainer: {
        display: "flex",
        flexDirection: "column",
        width: 250,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 0,
        top: 60,
        bottom: 10,
        marginLeft: "-20px",
    },

    contentContainer: {
        backgroundColor: theme.palette.background.default,
        outlineColor: "transparent",
        transition:
            "color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,outline-color .15s ease-in-out",
        borderRadius: 0,
        boxShadow: "none",
        padding: 0,
        width: "100%",
        //paddingLeft: 6,
    },

    dialog: {
        maxHeight: "100%",
        overflowY: "hidden",
        padding: 6,
    },
}));

interface ViewWithSearchSidebarContainerProps {
    headerComponent: JSX.Element;
    sidebarComponent: JSX.Element;
    contentComponent: JSX.Element;
    isOpenAsDialog: boolean;
    handleClose: any;
}

const ViewWithSearchHeaderContainer: FunctionComponent<
    ViewWithSearchSidebarContainerProps
> = ({
    headerComponent,
    sidebarComponent,
    contentComponent,
    isOpenAsDialog,
    handleClose,
}): JSX.Element => {
    const [height, setHeight] = useState(0);
    const { classes } = useStyles();
    const timestamp = Date.now();

    const ref = useRef(null);

    useEffect(() => {
        // @ts-ignore
        setHeight(ref?.current?.clientHeight || 0);
    }); //empty dependency array so it only runs once at render

    /*************************************
     *              RENDERER             *
     *************************************/
    const renderWrapper = () => {
        return (
            <>
                <div ref={ref}>
                    {headerComponent}
                    {sidebarComponent}
                </div>
                <div
                    className={classes.container}
                    style={{
                        // @ts-ignore
                        height: "calc(100% - " + height + "px)",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            height: "100%",
                            width: "100%",
                            overflowY: "hidden",
                            paddingTop: 6,
                        }}
                    >
                        <Paper
                            className={classes.contentContainer}
                            style={{
                                overflowY: "scroll",
                            }}
                        >
                            {contentComponent}
                        </Paper>
                    </div>
                </div>
            </>
        );
    };

    return renderWrapper();
};

export default ViewWithSearchHeaderContainer;
